<!-- profile-menu.component.html -->
 <ng-template #alertHost></ng-template>
<div class="overlay" (click)="onClose()">
  <div class="drawer" (click)="$event.stopPropagation()">

    <!-- Close Button -->
    <button class="close-btn" (click)="onClose()">✕</button>

    <!-- Profile Header -->
    <div class="profile-header">
      <div class="avatar-wrap">
        <div class="avatar">
          <mat-icon>person</mat-icon>
          <img src="https://img.d4040p.com/dp/h5/assets/images/player/vip/memberpic-lv1.svg?v=1777968960008" alt="">
        </div>
      </div>
      <div class="user-info">
        <div class="username">{{ user.name}}</div>
        <!-- <div class="user-id">ID &nbsp;<span>{{ user.id }}</span></div> -->
        <!-- <div class="vip-row">
          VIP Points (VP) &nbsp;<span class="vip-pts">{{ user.vipPoints }}</span>
          <span class="vip-badge">My VIP</span>
        </div> -->
      </div>
    </div>

    <!-- Wallets -->
    <div class="wallet-row">
      <div class="wallet-item">
        <div class="wallet-label">
          {{'CASH' | translate}}
          <!-- <mat-icon class="wallet-icon">refresh</mat-icon>
          <mat-icon class="wallet-icon">visibility</mat-icon> -->
        </div>
        <div class="wallet-amount">
          <span class="currency">৳</span> {{ user.mainWallet }}
        </div>
      </div>
      <div class="wallet-divider"></div>
      <div class="wallet-item">
        <div class="wallet-label">
          {{'BONUS' | translate}}
          <!-- <mat-icon class="wallet-icon">refresh</mat-icon>
          <mat-icon class="wallet-icon">account_balance_wallet</mat-icon> -->
        </div>
        <div class="wallet-amount">
          <span class="currency">৳</span> {{ user.bonusWallet }}
        </div>
      </div>
    </div>
    <div class="wallet-row">
      <div class="wallet-item">
        <div class="wallet-label">
          {{'BONUS_WAGER' | translate}}
          <!-- <mat-icon class="wallet-icon">refresh</mat-icon>
          <mat-icon class="wallet-icon">visibility</mat-icon> -->
        </div>
        <div class="wallet-amount">
          <span class="currency">৳</span> {{ Requiredbonus }}
        </div>
      </div>
      <div class="wallet-divider"></div>
      <div class="wallet-item">
        <div class="wallet-label">
          {{'Locked_Bonus' | translate}}
          <!-- <mat-icon class="wallet-icon">refresh</mat-icon>
          <mat-icon class="wallet-icon">account_balance_wallet</mat-icon> -->
        </div>
        <div class="wallet-amount">
          <span class="currency">৳</span> {{lockBonus}}
        </div>
      </div>
    </div>

    <!-- Scrollable Content -->
    <div class="scroll-content">

      <!-- Funds Section -->
      <div class="section">
        <div class="section-title">Funds</div>
        <div class="menu-grid grid-4">
          <div class="menu-item" *ngFor="let item of funds" (click)="openmodal(item)">
            <div class="menu-icon">
              <!-- <mat-icon>{{ item.icon }}</mat-icon> -->
              <img class="sidemeni_icon_div" src="{{item.iconimg}}" alt="">

            </div>
            <div class="menu-label">{{ item.label | translate}}</div>
          </div>
        </div>
      </div>

      <!-- My Promotion Section -->
      <div class="section">
        <div class="section-title">My Promotion</div>
        <div class="menu-grid grid-4">
          <div class="menu-item" *ngFor="let item of promotions" (click)="promotionsLink()" >
            <div class="menu-icon">
              <!-- <div class="menu-icon" [class.has-badge]="item.badge"> -->
              <img class="sidemeni_icon_div" src="{{item.iconimg}}" alt="">
            </div>
            <div class="menu-label">{{ item.label | translate }}</div>
          </div>
        </div>
      </div>

      <!-- History Section -->
      <div class="section">
        <div class="section-title">History</div>
        <div class="menu-grid grid-3">
          <div class="menu-item" *ngFor="let item of history" (click)="openmodal(item)">
            <div class="menu-icon">
              <img class="sidemeni_icon_div" src="{{item.iconimg}}" alt="">
            </div>
            <div class="menu-label">{{ item.label | translate }}</div>
          </div>
        </div>
      </div>

      <!-- Profile Section -->
      <div class="section">

        <div class="section-title">Profile</div>

        <div class="menu-grid grid-3">

          <div class="menu-item" *ngFor="let item of profile" (click)="openmodal(item)">

            <div class="menu-icon">
              <img class="sidemeni_icon_div" [src]="item.iconimg" alt="">
            </div>

            <div class="menu-label">
              {{ item.label | translate}}
            </div>

          </div>

        </div>

      </div>

      <!-- Contact Us Section -->
      <div class="section">
        <div class="section-title">Contact Us</div>
        <div class="menu-grid grid-4">
          <div class="menu-item" *ngFor="let item of contacts" (click)="openwindow(item.Link)">
            <div class="menu-icon" >
              <img class="sidemeni_icon_div" src="{{item.iconimg}}" alt="">
            </div>
            <div class="menu-label">{{ item.label }}</div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="">
          <button (click)="onClickLogout()" class="logout_btn"> 
              <img class="" src="../../../assets/siteImg/profiledrop_icon/icon-logout.png" alt="">
              {{'LOGOUT' | translate}}
          </button>
        </div>
      </div>

    </div>


  </div>
</div>